/**
 * SearchMaskLeft component
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled search left mask.
 */
const SearchMaskLeft = styled.div`
  background: linear-gradient(88deg, #0f0f0f 1.48%, rgba(15, 15, 15, 0) 71.68%);
  height: ${418 * Screen.widthRatio}px;
  width: ${187 * Screen.widthRatio}px;
  left: ${1173 * Screen.widthRatio}px;
  position: absolute;
`;

export default SearchMaskLeft;
